import getCdiData from './getCdiData'
export const getCdiDataPromise = getCdiData;